import(/* webpackMode: "eager" */ "/workspace/app/publications/components/Products.jsx")